import { createPlatformModel } from "./model";
import { createPlatformService } from "./service";

export const createPlatformStore = () => {
  return {
    model: createPlatformModel(),
    service: createPlatformService()
  };
};
